"use strict";

exports.__esModule = true;
var _AlertListScreen = require("./AlertListScreen");
Object.keys(_AlertListScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AlertListScreen[key]) return;
  exports[key] = _AlertListScreen[key];
});